import Checkout from "./components/Checkout";
import Header from "./components/Header";
import Home from "./components/Home";
import Login from "./components/Login";
import Register from "./components/Register";
import Orders from "./components/Orders"
import Error from "./components/Error"
import Footer from "./components/Footer"
import {BrowserRouter as Router, Switch, Route} from "react-router-dom"

import {useEffect} from "react"
import { auth } from "./firebase";
import {setUser} from "./redux/userSlice"
import {useDispatch} from "react-redux"
import Payment from "./components/Payment";
import { loadStripe } from "@stripe/stripe-js";
import {Elements} from "@stripe/react-stripe-js"


const promise = loadStripe('pk_test_51LFHVVJA3lOCfyRhogWE2udzSdFMfeheiQA0Y8WkewPpUwCIKqHbppZwtS4B6oOQaPfZdEMMxapMhEtB2TbgCtOf00mEWbZILz')


function App() {
     useEffect(()=> alert("This app is a demo. Please create an account and sign in prior to making a purchase. Then add items to cart and proceed to checkout. When trying to proceed to make a purchase please use the demo card {4242 4242 4242 4242 04/24 242 42424} Give it a moment for stripe to process transaction and continue shopping."), [])


      const dispatch = useDispatch()

      useEffect(()=> {
            auth.onAuthStateChanged(authUser=> {

                  if(authUser){
                        dispatch(setUser(authUser.email))
                  }
                  else{

                  }

            })
      }, [])



  return (
    <div className="App">
         <Router>
              <Switch>

              <Route exact path="/login">
                        <Login/>
              </Route>

              <Route exact path="/">
                        <Header/>
                        <Home/>
                        <Footer/>
              </Route>
              
              <Route exact path="/checkout">
                        <Header/>
                        <Checkout/>
                        <Footer/>

              </Route>

              <Route exact path="/register">
                        <Register/>
              </Route>


              <Route exact path="/payment">
                        <Header/>
                        <Elements stripe={promise}>
                              <Payment/>
                        </Elements>
                        <Footer/>

              </Route>

              <Route exact path="/orders">
                        <Header/>
                        <Orders/>
                        <Footer/>

              </Route>

              <Route exact path="/error">
                        <Header/>
                        <Error/>
                        <Footer/>

              </Route>
              </Switch>
        </Router>
      </div>
  );
}

export default App;
